import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideMenu, lucideMoon, lucideSun } from '@ng-icons/lucide';
import { BrnSheetContentDirective, BrnSheetTriggerDirective } from '@spartan-ng/brain/sheet';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { HlmIconDirective } from '@spartan-ng/ui-icon-helm';
import { HlmSheetComponent, HlmSheetContentComponent, HlmSheetHeaderComponent } from '@spartan-ng/ui-sheet-helm';
import { ThemeService } from '../../services/theme.service';
import { LogoIconComponent } from '../logo-icon/logo-icon.component';
import { LogoWithTextComponent } from '../logo-with-text/logo-with-text.component';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    LogoIconComponent,
    LogoWithTextComponent,
    BrnSheetTriggerDirective,
    BrnSheetContentDirective,
    HlmSheetComponent,
    HlmSheetHeaderComponent,
    HlmSheetContentComponent,
    HlmButtonDirective,
    HlmIconDirective,
    NgIcon,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  providers: [provideIcons({ lucideMoon, lucideSun, lucideMenu })],
})
export class HeaderComponent {
  private themeService = inject(ThemeService);

  toggleDarkMode() {
    this.themeService.toggleDarkMode();
  }
}
